var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Service Locations")]),_c('LocationsTable',{attrs:{"locations":_vm.serviceLocations,"locationType":_vm.LocationTypes.SERVICE}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }